<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/me7DqF/tc-custom/9781571318602.jpg?1704322308032" alt="This image is the cover for the book Hotel Lobby at the Edge of the World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hotel Lobby at the Edge of the World
      </h1>
      <p class="bookDescription body article font2">
        <b>“At the edge of the world, you’ll want to have this book. The final lines of Adam Clay’s poem, ‘Scientific Method,’ have been haunting me for weeks.” —<i>Iowa Press-Citizen</i></b><br/><br/>The distilled, haunting, and subtly complex poems in Adam Clay’s <i>A Hotel Lobby at the Edge of the World</i> often arrive at that moment when solitude slips into separation, when a person suddenly realizes he can barely see the place he set out from however long ago. He now sees he must find his connection back to the present, socially entangled world in which he lives. For Clay, reverie can be a siren’s song, luring him to that space in which prisoners will begin “to interrogate themselves.”<br/><br/>Clay pays attention to the poet’s return to the world of his daily life, tracking the subtly shifting tenors of thought that occur as the landscape around him changes. Clay is fully aware of the difficulties of Thoreau’s “border life,” and his poems live somewhere between those of James Wright and John Ashbery: They seek wholeness, all the while acknowledging that “a fragment is as complete as thought can be.” In the end, what we encounter most in these poems is a generous gentleness—an attention to the world so careful it’s as if the mind is “washing each grain of sand.”<br/><br/>“Poems that are in turn clear and strange, and always warmly memorable.” —Bob Hicok<br/><br/>“These poems engage fully the natural world . . . even as they understand the individual’s exclusion from it.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Clay
      </h2>
      
      <p class="authorDescription body article"><B>Adam Clay</B> is the author of <I>The Wash</I> (Parlor Press, 2006) and three chapbooks. His work has been published in <I>A Public Space</I>, <I>Gulf Coast</I>, and <I>The Iowa Review</I>. He co-edits <I>Typo Magazine</I>, curates the Poets in Print Reading Series at the Kalamazoo Book Arts Center, and teaches at Western Michigan University. He lives in Kalamazoo, Michigan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d819a234